import { render, staticRenderFns } from "./Archives.vue?vue&type=template&id=29b2fd75&scoped=true"
import script from "./Archives.vue?vue&type=script&lang=js"
export * from "./Archives.vue?vue&type=script&lang=js"
import style0 from "./Archives.vue?vue&type=style&index=0&id=29b2fd75&prod&lang=scss&scoped=true"
import style1 from "./Archives.vue?vue&type=style&index=1&id=29b2fd75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b2fd75",
  null
  
)

export default component.exports